import { fail, success } from '@helpers/result-helper'
import toast from '@services/toasts/index'
import { isSuccess, isHttpStatus } from '@/helpers/http-status-helpers'
import dayjs from '@/services/date/index'
import { isCacheFresh } from '@/helpers/cache-helpers'

const getDefaultState = () => {
  return {
    loadingCount: 0,
    crudLoadingCount: 0,
    pendingFeedback: [],
  }
}

const state = getDefaultState()

export default {
  namespaced: true,
  state,
  getters: {
    moduleName: () => 'pending-feedback',
    isLoading: (state) => state.loadingCount > 0,
    isLoadingCRUD: (state) => state.crudLoadingCount > 0,
    pendingFeedback: (state) => (clientId) =>
      state.pendingFeedback.find((feedback) => feedback.clientId === clientId)
        ?.list || [],
    pendingFeedbackCacheObj: (state) => (clientId) =>
      state.pendingFeedback.find((feedback) => feedback.clientId === clientId),
  },
  mutations: {
    START_LOADING(state) {
      state.loadingCount++
    },
    FINISH_LOADING(state) {
      state.loadingCount--
    },
    START_LOADING_CRUD(state) {
      state.crudLoadingCount++
    },
    FINISH_LOADING_CRUD(state) {
      state.crudLoadingCount--
    },
    SET_PENDING_FEEDBACK(state, { clientId, feedback }) {
      const found = state.pendingFeedback.find(
        (feedback) => feedback.clientId === clientId
      )

      if (found) {
        found.list = feedback
        found.lastUpdated = dayjs()
        return
      }

      state.pendingFeedback.push({
        clientId,
        list: feedback,
        lastUpdated: dayjs(),
      })
    },
    SET_FEEDBACK_AS_COMPLETE(state, { bookingId, clientId }) {
      const foundClientFeedbackList = state.pendingFeedback.find(
        (feedback) => feedback.clientId === clientId
      )

      if (!foundClientFeedbackList) return

      const foundBookingFeedback = foundClientFeedbackList.list.find(
        (feedback) => feedback.bookingID === bookingId
      )

      if (!foundBookingFeedback) return

      foundBookingFeedback.feedbackCompleted = true
    },
  },
  actions: {
    async getPendingFeedbacks({ commit, getters }, clientId) {
      // Check if cached
      const isCached = getters.pendingFeedbackCacheObj(clientId)

      if (
        isCached &&
        isCacheFresh({
          cacheDuration: 5,
          durationUnits: 'minutes',
          lastUpdated: isCached?.lastUpdated,
        })
      )
        return Promise.resolve(success(isCached.list))

      commit('START_LOADING')
      try {
        const response = await this.$api.pendingfeedbacks.getPendingFeedbacks(
          clientId
        )

        if (isSuccess(response.status)) {
          commit('SET_PENDING_FEEDBACK', { clientId, feedback: response.data })
          return success(response.data)
        }
      } catch (ex) {
        if (isHttpStatus(ex.response.status, 'Forbidden')) {
          return fail(null, '', 403)
        }

        toast.error(this.$i18n.t('pendingFeedbacks.pendingFeedbacksError'))
        return fail()
      } finally {
        commit('FINISH_LOADING')
      }
    },
    setFeedbackAsComplete({ commit }, { bookingId, clientId }) {
      commit('SET_FEEDBACK_AS_COMPLETE', { bookingId, clientId })
    },
  },
}
